import React from "react";
import { useTranslation } from "react-i18next";

const History = () => {
  const { t } = useTranslation();
  return (
    <div className="container text-relevant text-justify">
      <h1>{t("history")}</h1>
      <p>{t("history-p1")}</p>
      <p>{t("history-p2")}</p>
      <p>{t("history-p3")}</p>
      <p>{t("history-p4")}</p>
      <p>{t("history-p5")}</p>
      <p>{t("history-p6")}</p>
      <p>{t("history-p7")}</p>
      <p>{t("history-p8")}</p>
      <p>{t("history-p9")}</p>
      <p>{t("history-p10")}</p>
      <p>{t("history-p11")}</p>
      <p>{t("history-p12")}</p>
      <p>{t("history-p13")}</p>
      <p>{t("history-p14")}</p>
      <p>{t("history-p15")}</p>
      <p>{t("history-p16")}</p>
      <p>{t("history-p17")}</p>
      <p>{t("history-p18")}</p>
      <p>{t("history-p19")}</p>
      <p>{t("history-p20")}</p>
      <p>{t("history-p21")}</p>
      <p>{t("history-p22")}</p>
      <p>{t("history-p23")}</p>
      <p>{t("history-p24")}</p>
      <p>{t("history-p25")}</p>
    </div>
  );
};

export default History;
